module.exports = __webpack_public_path__ + "img/antes_despues_119.4f7ec027.png";